import { useMemo, useState } from "react";

import {
  DATE_RANGE_OPTIONS,
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  DEFAULT_UPLOAD_DATE_RANGE_ID,
  FILTER_ALL_VALUE,
} from "constants/constants";

import { filterUploadHistoryRows } from "../utils/uploadsUtils";

const useUploadHistoryTable = ({ uploadHistory, scriptId }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(FILTER_ALL_VALUE);
  const [dateRange, setDateRange] = useState(DEFAULT_UPLOAD_DATE_RANGE_ID);
  const [page, setPage] = useState(DEFAULT_PAGE_NUMBER);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const selectedDateRange =
    DATE_RANGE_OPTIONS.find((option) => option.id === dateRange) ||
    DATE_RANGE_OPTIONS[1];

  const filteredRows = useMemo(
    () =>
      filterUploadHistoryRows({
        uploadHistory,
        scriptId,
        searchTerm,
        statusFilter,
        dateRangeDays: selectedDateRange.days,
      }),
    [uploadHistory, scriptId, searchTerm, statusFilter, selectedDateRange.days]
  );

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const paginatedRows = filteredRows.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const startIndex =
    filteredRows.length === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endIndex = Math.min(currentPage * pageSize, filteredRows.length);

  const resetPage = () => setPage(DEFAULT_PAGE_NUMBER);

  const updateSearchTerm = (value) => {
    setSearchTerm(value);
    resetPage();
  };

  const updateStatusFilter = (value) => {
    setStatusFilter(value);
    resetPage();
  };

  const updateDateRange = (value) => {
    setDateRange(value);
    resetPage();
  };

  const updatePageSize = (value) => {
    setPageSize(value);
    resetPage();
  };

  return {
    searchTerm,
    statusFilter,
    dateRange,
    pageSize,
    currentPage,
    totalPages,
    filteredRows,
    paginatedRows,
    startIndex,
    endIndex,
    updateSearchTerm,
    updateStatusFilter,
    updateDateRange,
    updatePageSize,
    goToPage: setPage,
    goToPreviousPage: () => setPage((current) => current - 1),
    goToNextPage: () => setPage((current) => current + 1),
  };
};

export default useUploadHistoryTable;
